import * as exifr from 'exifr';
import type { ExifTimeParts } from './exifTime';

export interface PhotoExif {
  latitude?: number;
  longitude?: number;
  time: ExifTimeParts;
}

/** Reads GPS + raw time/offset from a photo file. Never throws — returns {} on failure. */
export async function readPhotoExif(file: File): Promise<PhotoExif> {
  const result: PhotoExif = { time: {} };
  try {
    const gps = await exifr.gps(file);
    if (gps && typeof gps.latitude === 'number' && typeof gps.longitude === 'number') {
      result.latitude = gps.latitude;
      result.longitude = gps.longitude;
    }
  } catch { /* no GPS — fine */ }

  try {
    // reviveValues:false keeps DateTimeOriginal as the raw "YYYY:MM:DD HH:MM:SS" string.
    const tags = await exifr.parse(file, { pick: ['DateTimeOriginal', 'OffsetTimeOriginal'], reviveValues: false });
    if (tags?.DateTimeOriginal) result.time.dateTimeOriginal = String(tags.DateTimeOriginal);
    if (tags?.OffsetTimeOriginal) result.time.offset = String(tags.OffsetTimeOriginal);
  } catch { /* no time — fine */ }

  return result;
}
